

import React, { useState, useEffect, useRef } from 'react';
import { Button } from '@mui/material';
import Grid from "@mui/material/Grid";
import { makeStyles } from '@mui/styles';
import Box from "@mui/material/Box";
import Backdrop from '@mui/material/Backdrop';
import Chip from '@mui/material/Chip';
import Fab from '@mui/material/Fab';
import CallIcon from '@mui/icons-material/Call';
import videoChatState from "./VideoWaitConnectPageStates";


const VideoWaitConnectPage = ({closePeerConnect, stream  , pageState,  streamRemote }) => {
    

  console.log('streamRemote', streamRemote);
    // const {socetInfo} = props;
    //console.log('peerInfo', peerInfo);
    console.log('pageState',  pageState);
   
    const classes = useStyles();
    //const localVideoref = React.createRef();

    const [screenHeight, setScreenHeight] = React.useState(window.innerHeight);
    //const [videoSizeFirst, setVideoSizeFirst] = React.useState(window.innerHeight/2);
    //const [videoSizeSecond, setVideoSizeSecond] = React.useState(window.innerHeight/2);

    
   // const [userCount, setUserCount] = React.useState(socetInfo.room_info.length);
    
   const videoRef = React.useRef(null);
   const videoRefRemount = React.useRef(null);
   
    //console.log('socetInfo', socetInfo);

    React.useEffect(() => {
        const handleResize = () => {
          //const height = window.innerHeight; 
          //const half = height /2; 
          setScreenHeight(window.innerHeight);
          //setVideoSizeFirst(half);
          //setVideoSizeSecond(half);
        };
        handleResize();
        //initCamera();

        if(stream){
          videoRef.current.srcObject = stream;
        }

        if(streamRemote){
          
          videoRefRemount.current.srcObject = streamRemote;
        }
    
        //window.addEventListener('resize', handleResize);
    
        return () => {
         // window.removeEventListener('resize', handleResize);
        };
      }, []);


      /*function initCamera(){
        navigator.mediaDevices
          .getUserMedia({ video: true, audio: true })
          .then((stream) => {
            // Установка видеопотока в элемент <video>
            if (refv.current) {
                refv.current.srcObject = stream;
                //streamToSave.current['MediaStream'] = stream;
                streamToSave(stream);
                //const clonedStream = stream.clone();
                //remontrefv.current.srcObject = clonedStream;

                
            }
            
          })
          .catch((error) => {
            console.log('Ошибка при получении доступа к камере/микрофону:', error);
            alert('Ошибка при получении доступа к камере/микрофону: ' + error);
          });
    }*/

    function closeButton(){
      closePeerConnect();
    }

    
    return (
       
        <Box> 

           {
            /*
             <div className={classes.container2}>
              <Chip sx={{background: 'white'}} label={"Гости: " + userCount} />
            </div>
            */
           }
            
            <Backdrop sx={{ color: '#F6F7F9', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={pageState ===videoChatState.Conected ? false: true}>
                <div className={classes.container}>
                     {pageState}
                </div>
            </Backdrop>

            <video ref={videoRef} style={{objectFit: 'cover',   height: screenHeight/2 }} autoPlay playsInline  />
            <video ref={videoRefRemount}   style={{objectFit: 'cover',  height: screenHeight/2 }} autoPlay playsInline  />
            
            {
              pageState ===videoChatState.Conected ? 

              <Fab sx={{background: 'red'}} className={classes.fab} onClick={closeButton}>
              <CallIcon  sx={{color: 'white'}}/>
              </Fab>
              : <></>
            }
          

        </Box>
                   
        
     
    );
  };


  
const useStyles = makeStyles((theme) => ({

    container: {
      display: 'flex',
      flexDirection: 'column',
      //background: '#f3f3f3',
      height: '100vh',
      width: '100%',
      padding: 0, 
      margin: 0, 
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center', 
      //color: 'red'
    },

    container2: {
      position: 'absolute', 
      top: 5, 
      left: 5
    },

    fab: {
      position: 'absolute !important',
      bottom: '20px',
      right: '20px',
      zIndex: 9999,
    },
    
   
  }));

  export default VideoWaitConnectPage;

